//src/layouts/auth/RegisterForm.js
import { useState } from "react";
import { registerUser } from "../../services/authService";
import { useNavigate } from "react-router-dom";

export default function RegisterForm() {
  // Hook điều hướng
  const navigate = useNavigate();

  // 📌 State lưu thông tin form đăng ký
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    phone: "",
  });

  // 📌 State lưu thông báo (thành công hoặc lỗi)
  const [message, setMessage] = useState("");

  // 📌 State để hiển thị trạng thái loading khi gửi request
  const [loading, setLoading] = useState(false);

  // 📌 Hàm xử lý khi thay đổi input
  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  // 📌 Hàm validate dữ liệu form trước khi gửi
  const validate = () => {
    const { name, email, password, phone } = formData;

    if (!name.trim()) {
      setMessage("Họ tên không được để trống");
      return false;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setMessage("Email không hợp lệ");
      return false;
    }

    if (!/^[0-9]{9,11}$/.test(phone)) {
      setMessage("Số điện thoại không hợp lệ");
      return false;
    }

    if (!password || password.length < 6) {
      setMessage("Mật khẩu phải ít nhất 6 ký tự");
      return false;
    }

    return true;
  };

  // 📌 Xử lý khi submit form
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    setLoading(true);
    try {
      const res = await registerUser({ ...formData, role: "users" });
      setMessage("Đăng ký thành công! 🎉");
      // Chuyển đến trang đăng nhập sau 1 giây
      setTimeout(() => {
        navigate("/login");
      }, 1000);

    } catch (err) {
      setMessage(err?.response?.data?.message || "Có lỗi xảy ra.");
    } finally {
      setLoading(false);  // tắt trạng thái loading
    }
  };

  return (
    <form className="space-y-4" onSubmit={handleSubmit}>
      {/* Họ tên */}
      <div>
        <label
          htmlFor="name"
          className="block text-sm font-medium text-gray-700 mb-1"
        >
          Họ tên
        </label>
        <input
          type="text"
          name="name"
          placeholder="Họ tên"
          className="w-full p-2 border rounded"
          value={formData.name}
          onChange={handleChange}
        />
      </div>
      {/* Email */}
      <div>
        <label
          htmlFor="email"
          className="block text-sm font-medium text-gray-700 mb-1"
        >
          Email
        </label>
        <input
          type="email"
          name="email"
          placeholder="Email"
          className="w-full p-2 border rounded"
          value={formData.email}
          onChange={handleChange}
        />
      </div>
      {/* Số điện thoại */}
      <div>
        <label
          htmlFor="phone"
          className="block text-sm font-medium text-gray-700 mb-1"
        >
          Số điện thoại
        </label>
        <input
          type="text"
          name="phone"
          placeholder="Số điện thoại"
          className="w-full p-2 border rounded"
          value={formData.phone}
          onChange={handleChange}
        />
      </div>
      {/* Mật khẩu */}
      <div>
        <label
          htmlFor="password"
          className="block text-sm font-medium text-gray-700 mb-1"
        >
          Mật khẩu
        </label>
        <input
          type="password"
          name="password"
          placeholder="Mật khẩu"
          className="w-full p-2 border rounded"
          value={formData.password}
          onChange={handleChange}
        />
      </div>
      {/* Nút đăng ký */}
      <button
        type="submit"
        disabled={loading}
        className={`w-full py-2 rounded text-white ${loading ? "bg-gray-400" : "bg-green-600 hover:bg-green-700"}`}
      >
        {loading ? "Đang đăng ký..." : "Đăng ký"}
      </button>
      {message && <p className="text-center text-sm text-red-600">{message}</p>}
    </form>
  );
}
